module.exports = __webpack_public_path__ + "static/img/highway.1e34e49d.svg";